

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/servizionline">SERVIZI ONLINE</a></span></li>
            <li class="last"><span><a href="/sirang/indicatoriambientali">Indicatori Ambientali</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_12lTD1whEJC3_">
                     <span id="p_56_INSTANCE_12lTD1whEJC3"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_12lTD1whEJC3">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Indicatori Ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article"> Il modulo per la gestione multidimensionale degli indicatori ambientali (MGIA) consente la creazione di indicatori ambientali a partire dai dati del SIRA, utili in particolare nella predisposizione di piani e programmi e nelle procedure di valutazione ambientale strategica (VAS) e per rispondere agli obblighi della Regione verso la rete SIRAnet. </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>